import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const updateScript = async ({ testStepId, testCaseId, scriptfile }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateScript&companyid=${user.companyid}&testCaseId=${testCaseId}&teststepid=${testStepId}&name=${scriptfile}&script=selectScript`,
    {
      teststepid: testStepId,
      testCaseId: testCaseId,
      script: "selectScript",
      scriptfile: scriptfile || "",
    },
  );

  return response.data;
};

const useScriptUpdateQuery = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateScript,
    onSuccess: () => {
      queryClient.invalidateQueries(["allApi", "testCaseResults"]);
    },
    onError: (error) => {
      console.log("Error updating script file", error.message);
    },
  });
};

export default useScriptUpdateQuery;
